var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTyperecordActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.127,
    height: 25.704,
    viewBox: "0 0 20.127 25.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type_record_audio",
    "data-name": "Type record audio",
    transform: "translate(22415.167 15117.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "microphone",
    d: "M35.126,26.354a10.072,10.072,0,0,1-8.386,9.912v1.815a1.677,1.677,0,1,1-3.354,0V36.267A10.072,10.072,0,0,1,15,26.354V24.677a1.677,1.677,0,1,1,3.354,0v1.677a6.709,6.709,0,1,0,13.417,0V24.677a1.677,1.677,0,1,1,3.354,0Z",
    transform: "translate(-22430.168 -15131.413)",
    fill: "#6aabfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "microphone-2",
    "data-name": "microphone",
    d: "M20,19.473a4.472,4.472,0,1,1,8.945,0V27.3A4.472,4.472,0,1,1,20,27.3Zm4.472,14.536Z",
    transform: "translate(-22429.578 -15132.358)",
    fill: "#0f7bff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyperecordActive);
export default __webpack_public_path__ + "static/media/TyperecordActive.52b5923b.svg";
export { ForwardRef as ReactComponent };